/**
 * Pipeline do orçamento (Bloco E / mig 379) — helpers de EXIBIÇÃO do chip de
 * urgência da entrega. O cálculo (label + urgência em dias úteis) vem PRONTO do
 * backend (shapeCard.entregaOrcamento); aqui é só cor/estilo e ordenação.
 *
 * Cores fiéis ao mockup: vermelho (atrasado/hoje), amarelo (amanhã), verde
 * (folga) — mesmo vocabulário visual de leads-reciclagem (text/bg-danger etc.).
 */
import type { UrgenciaEntrega } from './crm-types';

/** Classes Tailwind do chip por urgência (pill). */
export function classesChipUrgencia(urgencia: UrgenciaEntrega): string {
  switch (urgencia) {
    case 'atrasado':
    case 'hoje':
      return 'text-red dark:text-red-glow bg-red-soft dark:bg-red-soft-dark';
    case 'amanha':
      return 'text-warning bg-warning/10';
    case 'folga':
      return 'text-success bg-success/10';
  }
}

/** Peso de ordenação: mais urgente primeiro (atrasado → folga). */
export function pesoUrgencia(urgencia: UrgenciaEntrega): number {
  switch (urgencia) {
    case 'atrasado':
      return 0;
    case 'hoje':
      return 1;
    case 'amanha':
      return 2;
    case 'folga':
      return 3;
  }
}
